import { AncEventDto } from "./anc_event.dto";
import { INITIAL_SALE_EVENT_CONTEXT } from "../../../constants";
import { validateSessionByCookie } from "../../services/cookies";

const {
  env: environment,
  isApp: app,
  isCorpo: corp,
} = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");

export const handleAncEvent = (data: AncEventDto) => {
  const { event_params, event } = data;

  const ga4Event: AncEventDto = {
    event,
    event_params: {
      environment: event_params.environment ?? environment,
      ...(typeof app !== 'undefined' || typeof event_params.app !== 'undefined'
        ? { app: event_params.app ?? app }
        : {}),
      corp: event_params.corp ?? corp,
      ...(event_params.evento_interactivo_categoria && {
        evento_interactivo_categoria: event_params.evento_interactivo_categoria,
      }),
      ...(event_params.evento_interactivo_accion && {
        evento_interactivo_accion: event_params.evento_interactivo_accion,
      }),
      ...(event_params.evento_interactivo_etiqueta && {
        evento_interactivo_etiqueta: event_params.evento_interactivo_etiqueta,
      }),
      page_path: event_params.page_path,
      micrositio: event_params.micrositio ?? 'booking',
      page_type: event_params.page_type,
      homemarket: event_params.homemarket ?? 'chile',
      negocio: event_params.negocio ?? 'retail',
      buy_instance: event_params.buy_instance ?? 'IS',
      login: validateSessionByCookie(),
      initial_date: event_params.initial_date,
      end_date: event_params.end_date,
      from_iata: event_params.from_iata,
      to_iata: event_params.to_iata,
      trip_type: event_params.trip_type,
      passengers_adult: event_params.passengers_adult,
      passengers_child: event_params.passengers_child,
      passengers_infant: event_params.passengers_infant,
      passengers_pet: event_params.passengers_pet ?? 0,
      pax: event_params.pax,
      full_trip: event_params.full_trip,
      ...(event_params.full_trip_dates && {
        full_trip_dates: event_params.full_trip_dates,
      }),
      time: event_params.time,
      exchange_rate: event_params.exchange_rate ?? null,
      ...(event_params.count_seats && {
        count_seats: event_params.count_seats,
      }),
      ...(event_params.count_bags && {
        count_bags: event_params.count_bags,
      }),
      ...(event_params.count_carry_on && {
        count_carry_on: event_params.count_carry_on,
      }),
      fare_basis: event_params.fare_basis,
      ...(event_params.bundle && { bundle: event_params.bundle }),

      ...(event_params.ecommerce && {
        ecommerce: {
          ...event_params.ecommerce,
          ...(event_params.ecommerce?.transaction_id && {
            transaction_id: event_params.ecommerce.transaction_id,
          }),
          ...(event_params.ecommerce?.affiliation && {
            affiliation: event_params.ecommerce.affiliation,
          }),
          ...(event_params.ecommerce?.pnr && {
            pnr: event_params.ecommerce.pnr,
          }),
          ...(event_params.ecommerce?.Payment_method && {
            Payment_method: event_params.ecommerce.Payment_method,
          }),
          ...(event_params.ecommerce?.tax && { tax: event_params.ecommerce.tax }),
          ...(event_params.ecommerce?.value && { value: event_params.ecommerce.value }),
          ...(event_params.ecommerce?.items && {
            items: event_params.ecommerce.items.map((item) => ({
              index: item.index,
              item_id: item.item_id,
              item_category: item.item_category,
              item_list_name: item.item_list_name,
              item_name: item.item_name,
              quantity: item.quantity,
              ...(item.cabin && { cabin: item.cabin }),
              ...(item.item_variant && { item_variant: item.item_variant }),
              ...(item.price !== undefined && { price: item.price }),
            })),
          }),
        },
      }),
      userProperties: {
        pas_dni_hashed: event_params.userProperties?.pas_dni_hashed ?? null,
        birthday: event_params.userProperties?.birthday ?? null,
      },
    },
  };

  if (event_params.ecommerce) {
    ga4Event.event_params.ecommerce = data.event_params.ecommerce;
  }

  return ga4Event;
};